import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import {
  updateRestoreAppointmentModalVisibility,
  updateSendRestorationEmailToggle
} from "../../../actions/menu";
import { updateBooking, sendBookingEmail } from "../../../actions/booking";
import { Checkbox } from "semantic-ui-react";
import { toApiDateTime } from "../../../utils/helpers";
@connect(mapStateToProps)
export default class RestoreAppointmentModal extends Component {
  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  updateRestoreAppointmentVisibility = isVisible => {
    this.props.dispatch(updateRestoreAppointmentModalVisibility(isVisible));
  };

  getRestoreAppointmentModal = () => {
    let {
      currentBookingId,
      advancedAppointmentStepData,
      appointmentStepData,
      gotValidOffer,
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
      restoreAppointmentModalVisible
    } = this.props;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;
    let {
      updateRestoreAppointmentModalVisibility,
      savingBooking,
      sendRestorationEmailToggled
    } = this.props;
    let {
      ThisOnly,
      ThisAndFuture,
      RestoreRecurrentAppointmentText,
      RestoreRecurringAppText
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    let {
      No,
      Yes,
      RestorationEmailToggleTitle
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    let { selectedCustomer } = appointmentStepData;
    if (!restoreAppointmentModalVisible) {
      return "";
    }

    let handleRestoreAppointment = applyto => {
      let {
        selectedDate,
        selectedTime
      } = appointmentStepData.multiServiceList[0];

      let payload = { status: 3 };
      if (applyto && applyto === "thisonly") {
        payload = { status: 3, applyto: "thisonly" };
        advancedAppointmentStepData.recurringToggleOn = false; // disable recurring to avoid creating a second-timeline
      } else if (applyto && applyto === "thisandfuture") {
        payload = { status: 3, applyto: "thisandfuture" };
      }

      let cb = () => {
        this.closeApp();
      };
      if (sendRestorationEmailToggled) {
        let starttime = toApiDateTime(
          selectedDate,
          selectedTime.stringValue,
          appointmentStepData.timeList
        );
        this.props.dispatch(
          sendBookingEmail(currentBookingId, 3, payload.applyto, starttime, cb)
        );
      } else if (currentBookingId) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            gotValidOffer,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    };

    let saveButtonClasses = "ui button  savebtn";
    let discardButtonClasses = "ui button cancel-btn";
    let thisOnlyButtonClasses = "ui button recur-btn";
    let thisandfutureButtonClasses = "ui button recur-btn2";

    let recurringButtons = () => {
      return (
        <div>
          <div
            className={thisOnlyButtonClasses}
            onClick={() => handleRestoreAppointment("thisonly")}
          >
            {ThisOnly}
          </div>
          <div
            className={thisandfutureButtonClasses}
            onClick={() => handleRestoreAppointment("thisandfuture")}
          >
            {ThisAndFuture}
          </div>
        </div>
      );
    };

    if (savingBooking) {
      saveButtonClasses += " loading disabled";
      discardButtonClasses += " disabled";
      thisOnlyButtonClasses += " disabled";
      thisandfutureButtonClasses += " disabled";
    }

    let normalRestoreButtons = () => {
      return (
        <div>
          <div
            className={discardButtonClasses}
            onClick={() => this.updateRestoreAppointmentVisibility(false)}
          >
            {No}
          </div>
          <div
            className={saveButtonClasses}
            onClick={() => handleRestoreAppointment("thisonly")}
          >
            {Yes}
          </div>
        </div>
      );
    };

    let handleRestorationEmailToggle = () => {
      this.props.dispatch(
        updateSendRestorationEmailToggle(!sendRestorationEmailToggled)
      );
    };

    return (
      <Modal
        className="bookingdetails-model cancel-appointment-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className={`save-box ${recurringToggleOn ? "recurrences" : ""}`}>
            <section className="header">
              {window.APP.LANGUAGE.Pages.Appointment.ConfirmRestore}
              {recurringToggleOn ? (
                <p className="save_text">{RestoreRecurringAppText}</p>
              ) : (
                ""
              )}
              <div
                className="close_button"
                onClick={() => this.updateRestoreAppointmentVisibility(false)}
              ></div>
            </section>

            <section className="save_box_buttons">
              {recurringToggleOn ? recurringButtons() : normalRestoreButtons()}
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  render() {
    return this.getRestoreAppointmentModal();
  }
}

function mapStateToProps(state) {
  return {
    message: state.globalErrorReducer.message,
    cancelAppointmentVisible: state.menuReducer.cancelAppointmentVisible,
    savingBooking: state.bookingReducer.savingBooking,
    restoreAppointmentModalVisible:
      state.menuReducer.restoreAppointmentModalVisible,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    sendRestorationEmailToggled: state.menuReducer.sendRestorationEmailToggled,
    currentBookingId: state.bookingReducer.currentBookingId,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData
  };
}
